Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
function pauseElementBasedMedia(element) {
  element.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  element.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  element.querySelectorAll("video").forEach((video) => video.pause());
  element.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}
if (!customElements.get("smooth-anchor")) {
  customElements.define(
    "smooth-anchor",
    class SmoothAnchor extends HTMLElement {
      constructor() {
        super();

        this.anchor = this.querySelector("a")
          ? this.querySelector("a")
          : this.querySelector("button");
        this.anchor.addEventListener("click", this.onClickRef.bind(this));
      }

      onClickRef() {
        event.preventDefault();

        const targetId = this.anchor.getAttribute("href");
        const targetElement = document.querySelector(targetId);

        if (targetElement) {
          if (this.dataset.offset) {
            let offset = 0;
            const offsetElement = document.querySelector(this.dataset.offset);
            if (!offsetElement) {
              doScroll();
              if (targetElement.nodeName.toLowerCase() === "input")
                targetElement.focus();
              return;
            }
            const elementPosition = targetElement.getBoundingClientRect().top;
            offset =
              elementPosition + window.scrollY - offsetElement.offsetHeight;
            window.scrollTo({
              top: offset,
              behavior: "smooth",
            });
            if (targetElement.nodeName.toLowerCase() === "input")
              targetElement.focus();
            return;
          }
          doScroll();
          if (targetElement.nodeName.toLowerCase() === "input")
            targetElement.focus();
        }

        function doScroll() {
          targetElement.scrollIntoView({
            behavior: "smooth",
          });
        }
      }
    }
  );
}
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}
customElements.define("deferred-media", DeferredMedia);
if (!customElements.get("quantity-input")) {
  customElements.define(
    "quantity-input",
    class QuantityInput extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector("input");
        this.changeEvent = new Event("change", { bubbles: true });
        this.qtySubtotal = this.querySelector(".quantity_subtotal");

        this.input.addEventListener("change", this.onInputChange.bind(this));
        this.querySelectorAll("button").forEach((button) =>
          button.addEventListener("click", this.onButtonClick.bind(this))
        );
      }

      quantityUpdateUnsubscriber = undefined;

      connectedCallback() {
        if (this.qtySubtotal) this.initQtyPrice = this.qtySubtotal.innerText;

        // this.validateQtyRules();
        this.quantityUpdateUnsubscriber = subscribe(
          PUB_SUB_EVENTS.quantityUpdate,
          this.validateQtyRules.bind(this)
        );
      }

      disconnectedCallback() {
        if (this.quantityUpdateUnsubscriber) {
          this.quantityUpdateUnsubscriber();
        }
      }

      onInputChange() {
        this.validateQtyRules();
      }

      onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        if (
          event.target.name === "plus" ||
          event.target.parentElement.name === "plus"
        ) {
          this.input.stepUp();
        } else {
          this.input.stepDown();
        }

        // event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value)
          this.input.dispatchEvent(this.changeEvent);
      }

      validateQtyRules(variant = null) {
        const value = parseInt(this.input.value);

        if (variant) {
          this.setVariantUpdates(value, variant);

          return;
        }

        if (this.input.min) {
          const min = parseInt(this.input.min);
          const buttonMinus = this.querySelector(
            ".quantity_button[name='minus']"
          );
          buttonMinus.classList.toggle("disabled", value <= min);
          buttonMinus.toggleAttribute("disabled", value <= min);
        }
        if (this.input.max) {
          const max = parseInt(this.input.max);
          const buttonPlus = this.querySelector(
            ".quantity_button[name='plus']"
          );
          buttonPlus.classList.toggle("disabled", value >= max);
          buttonPlus.toggleAttribute("disabled", value >= max);
        }

        if (this.qtySubtotal) {
          const parentCard = this.closest("product-card");
          const currPrice = parentCard.getCurrentPriceData();
          let multiplePrice = currPrice * value;

          if (value > 1) {
            this.qtySubtotal.innerText = Shopify.formatMoney(
              multiplePrice,
              window.money_format
            );

            return;
          }

          multiplePrice = currPrice * 1;
          this.qtySubtotal.innerText = Shopify.formatMoney(
            multiplePrice,
            window.money_format
          );
        }
      }

      setVariantUpdates(val, rule) {
        const minVal = rule.min;
        const maxVal = rule.max;
        const incrVal = rule.increment;

        if (this.input.min) {
          this.input.setAttribute("min", minVal);
          const min = parseInt(minVal);
          const buttonMinus = this.querySelector(
            ".quantity_button[name='minus']"
          );
          buttonMinus.classList.toggle("disabled", val <= min);
          buttonMinus.toggleAttribute("disabled", val <= min);
        }
        if (this.input.max) {
          this.input.setAttribute("max", maxVal);
          const max = parseInt(maxVal);
          const buttonPlus = this.querySelector(
            ".quantity_button[name='plus']"
          );
          buttonPlus.classList.toggle("disabled", val >= max);
          buttonPlus.toggleAttribute("disabled", val >= max);
        }

        if (this.qtySubtotal) {
          const parentCard = this.closest("product-card");
          const currPrice = parentCard.getCurrentPriceData();
          const multiplePrice = currPrice * val;
          this.qtySubtotal.innerText = Shopify.formatMoney(
            multiplePrice,
            window.money_format
          );
        }
      }

      setResetSubtotals(price) {
        if (!this.qtySubtotal) return;
        this.qtySubtotal.innerText = Shopify.formatMoney(
          price,
          window.money_format
        );
      }

      resetDefaults(price = null) {
        this.input.value = parseInt(this.input.min);
        if (price) this.setResetSubtotals(price);
      }

      toggleSubtotal(status) {
        if (!this.qtySubtotal) return;

        if (!status) {
          this.qtySubtotal.classList.add("hidden");
        } else {
          this.qtySubtotal.classList.remove("hidden");
        }
      }
    }
  );
}
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
const trapFocusHandlers = {};
function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}
// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}
function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}
if (!customElements.get("hideable-element")) {
  customElements.define(
    "hideable-element",
    class HideableElement extends HTMLElement {
      constructor() {
        super();
        this.elementToHide = this.querySelector("aside");
        this.elementToggle = this.querySelector(".js-contents--btn-close");
        const hasBeenHidden = localStorage.getItem(
          `${this.elementToHide.id}-hidden`
        );

        if (hasBeenHidden) {
          this.elementToHide.classList.add("hidebar");
        }

        if (this.elementToggle) {
          this.elementToggle.addEventListener("click", () => {
            this.elementToHide.style.display = "none";
            localStorage.setItem(`${this.elementToHide.id}-hidden`, true);
          });
        }
      }
    }
  );
}
// Countdown_Timer
if (!customElements.get("countdown-timer")) {
  customElements.define(
    "countdown-timer",
    class CountdownTimer extends HTMLElement {
      constructor() {
        super();
        const endDate = new Date(this.getAttribute("end-date"));
        if (isNaN(endDate)) {
          //this.innerHTML = '<div class="block"> <span class="time">0</span> <span class="text">day</span> </div> <div class="block"> <span class="time">0</span> <span class="text">hour</span> </div> <div class="block"> <span class="time">0</span> <span class="text">min</span> </div> <div class="block"> <span class="time">0</span> <span class="text">sec</span> </div>';
          this.classList.add("hidden");
          const message = this.nextElementSibling;
          if (
            !message ||
            !message.classList.contains("countdown-timer_message")
          )
            return;
          message.classList.remove("hidden");
          return;
        } else {
          const remainingTime = endDate.getTime() - Date.now();
          if (remainingTime <= 0) {
            this.innerHTML = `<div class="block"> <span class="time">0</span> <span class="text">${window.additionalStrings.countdown_days_label}</span> </div> <div class="block"> <span class="time">0</span> <span class="text">${window.additionalStrings.countdown_hours_label}</span> </div> <div class="block"> <span class="time">0</span> <span class="text">${window.additionalStrings.countdown_min_label}</span> </div> <div class="block"> <span class="time">0</span> <span class="text">${window.additionalStrings.countdown_sec_label}</span> </div>`;
          } else {
            this.remainingTime = remainingTime;
            this.innerHTML = this.getTimeString();
          }
        }
      }

      connectedCallback() {
        if (isNaN(this.remainingTime)) {
          this.classList.add("hidden");
          const message = this.nextElementSibling;
          if (
            !message ||
            !message.classList.contains("countdown-timer_message")
          )
            return;
          message.classList.remove("hidden");
          return;
        }
        this.intervalId = setInterval(() => {
          this.remainingTime -= 1000;
          this.innerHTML = this.getTimeString();
          if (this.remainingTime <= 0) {
            clearInterval(this.intervalId);
            this.dispatchEvent(new Event("timeup"));
          }
        }, 1000);
      }

      getTimeString() {
        if (isNaN(this.remainingTime) || this.remainingTime <= 0) {
          //return '<div class="block"> <span class="time">0</span> <span class="text">days</span> </div> <div class="block"> <span class="time">0</span> <span class="text">hours</span> </div> <div class="block"> <span class="time">0</span> <span class="text">mins</span> </div> <div class="block"> <span class="time">0</span> <span class="text">secs</span> </div>';
          this.classList.add("hidden");
          const message = this.nextElementSibling;
          if (
            !message ||
            !message.classList.contains("countdown-timer_message")
          )
            return;
          message.classList.remove("hidden");
          return;
        }
        const days = Math.floor(this.remainingTime / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (this.remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor(
          (this.remainingTime % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor((this.remainingTime % (1000 * 60)) / 1000);
        return `<div class="block"> <span class="time">${days}</span> <span class="text">${window.additionalStrings.countdown_days_label}</span> </div> <div class="block"> <span class="time">${hours}</span> <span class="text">${window.additionalStrings.countdown_hours_label}</span> </div> <div class="block"> <span class="time">${minutes}</span> <span class="text">${window.additionalStrings.countdown_min_label}</span> </div> <div class="block"> <span class="time">${seconds}</span> <span class="text">${window.additionalStrings.countdown_sec_label}</span> </div>`;
      }
    }
  );
}

if (!customElements.get("accordion-wrapper")) {
  customElements.define(
    "accordion-wrapper",
    class AccordionWrapper extends HTMLElement {
      constructor() {
        super();

        this.toggle = this.querySelector("summary");
        if (this.toggle)
          this.toggle.addEventListener("click", this.accordion.bind(this));
      }

      accordion(event) {
        if (this.dataset.behavior === "open-close") this.setEventListners();
        if (
          this.toggle.parentElement.hasAttribute("open") &&
          this.dataset.behavior !== "open-close"
        )
          this.keepOpen(event);
        if (!this.toggle.parentElement.hasAttribute("open")) this.closeOther();
      }

      closeOther() {
        const allRows = document.querySelectorAll(
          `#${this.dataset.parent} details`
        );
        allRows.forEach((toggler) => {
          if (
            toggler.querySelector("summary") === this.toggle &&
            this.dataset.behavior !== "open-close"
          )
            return;
          toggler.removeAttribute("open");
        });
      }

      keepOpen(event) {
        const toggle = event.target.closest("details");
        toggle.removeAttribute("open");
      }

      setEventListners() {
        document.body.addEventListener("click", this.hideOutside.bind(this));
        this.addEventListener("keyup", this.onKeyUp.bind(this));
      }

      hideOutside(event) {
        const target = event.target;
        const boundings = this.querySelector(".collapsible-row_content");
        if (
          boundings.contains(target) ||
          target === boundings ||
          target.closest(".collapsible-row_content")
        )
          return;
        this.closeOther();
      }

      onKeyUp(event) {
        if (event.code.toUpperCase() !== "ESCAPE") return;
        this.closeOther();
      }
    }
  );
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}
Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};
Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};
Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};
Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};
Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};
Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};
function validation() {
  let email = document.querySelectorAll('[name="contact[email]"]');
  let pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  email.forEach((input) => {
    let text = input.closest("form").querySelector(".results-wrap_message");
    let button = input.closest("form").querySelector('[type="submit"]');
    if (input.value.match(pattern)) {
      if (text)
        text.innerHTML = window.accessibilityStrings.newsletterValidMessage;
      if (text) text.style.color = "var(--section-success-color)";
      input.classList.remove("form-control--error");
      if (button) button.removeAttribute("disabled");
    } else {
      if (text)
        text.innerHTML = window.accessibilityStrings.newsletterInValidMessage;
      if (text) text.style.color = "var(--section-error-color)";
      input.classList.add("form-control--error");
      if (button) button.setAttribute("disabled", "");
      if (event.keyCode == "13") {
        event.preventDefault();
      }
    }

    if (input.value == "") {
      if (text) text.innerHTML = "";
      if (text) text.style.color = "var(--section-success-color)";
      input.classList.remove("form-control--error");
      if (button) button.setAttribute("disabled", "");
    }
  });
}
document.addEventListener("DOMContentLoaded", function () {
  const compareListStorage = localStorage.getItem("comparelist");
  const comparelistContainer = document.querySelector(
    '[data-modal-main="compare"]'
  );
  if (!comparelistContainer) return;
  const comparelistOrganizer = document.querySelector(".compare-counter");
  const compareLimit = 3;
  let compareList = compareListStorage ? JSON.parse(compareListStorage) : [];

  if (compareList.length && compareList.length >= compareLimit) {
    comparelistContainer.classList.add("--limit-exceed");
  } else {
    comparelistContainer.classList.remove("--limit-exceed");
  }

  if (comparelistOrganizer) {
    comparelistOrganizer.innerText = compareList.length;
    const modalOpener = document.querySelector('[data-modal-main="compare"]');

    if (compareList.length === 0) {
      modalOpener.classList.add("hidden");
    } else if (compareList.length === 1) {
      modalOpener.classList.remove("hidden");
      modalOpener.classList.add("--disabled");
    } else {
      modalOpener.classList.remove("--disabled");
      modalOpener.classList.remove("hidden");
    }
  }

  const currentUrl = window.location.href;
  const url = new URL(currentUrl);
  const formType = url.searchParams.get("form_type");
  const msg = url.searchParams.get("contact[Message]");
  const contactPosted = url.searchParams.get("contact_posted");

  if (formType === "contact" || contactPosted === "true") {
    var hashIndex = currentUrl.indexOf("#");
    const popup =
      hashIndex !== -1
        ? document
            .getElementById(currentUrl.slice(hashIndex + 1))
            .closest("modal-component")
        : document.querySelector('[data-modal="modal-question-ask"]');
    if (popup) popup.open();
  }
});
if (!customElements.get("sticky-block")) {
  customElements.define(
    "sticky-block",
    class StickyBlock extends HTMLElement {
      constructor() {
        super();

        if (!this.dataset.refBlock && !this.dataset.behavior) return;
        this.onLoad = setTimeout(this.initialize.bind(this), 2000);
      }

      connectedCallback() {
        document.addEventListener("DOMContentLoaded", function () {
          this.onload;
        });
      }

      initialize() {
        this.behavior = this.dataset.behavior;
        this.spacer = this.dataset.spacer;
        this.endBounds = document.body.offsetHeight + this.offsetHeight;

        if (this.behavior) {
          switch (this.behavior) {
            case "downwards":
              window.addEventListener(
                "scroll",
                this.onDownwardScroll.bind(this)
              );
              break;
            case "upwards":
              window.addEventListener("scroll", this.onUpwardScroll.bind(this));
              break;
            case "stacked":
              window.addEventListener(
                "scroll",
                this.onStackedScroll.bind(this)
              );
              break;
            default:
              break;
          }
        }
        this.refBlock = document.querySelector(this.dataset.refBlock);
        if (!this.refBlock) return;

        this.refBoundings = this.refBlock.getBoundingClientRect();
        this.offset = this.dataset.offset ? parseFloat(this.dataset.offset) : 0;
        this.threshold =
          this.refBlock.offsetTop + this.refBoundings.height + this.offset;
        this.previousScrollAmount = window.screenY;
        this.percent = this.dataset.pagePercentage
          ? this.dataset.pagePercentage
          : null;

        if (this.spacer) this.height = this.refBlock.offsetHeight;
      }

      onDownwardScroll() {
        let revealedAttr = false;

        if (this.percent) {
          const pageHeight = document.documentElement.offsetHeight;
          const threshold = (pageHeight * parseFloat(this.percent)) / 100;
          this.threshold = threshold;
        }

        if (window.scrollY > this.threshold) {
          revealedAttr = true;
        }

        this.setStickyStatus(revealedAttr);
      }

      onUpwardScroll() {
        let revealedAttr = false;
        const threshold = this.height
          ? this.height
          : this.refBlock.offsetHeight;

        if (window.scrollY > this.previousScrollAmount) {
          revealedAttr = false;
        } else if (window.scrollY < this.previousScrollAmount) {
          revealedAttr = true;
          this.dropdownClose();

          if (window.scrollY < threshold) {
            revealedAttr = false;
          }
        }

        this.setStickyStatus(revealedAttr);
        this.previousScrollAmount = window.scrollY;
      }

      onStackedScroll() {
        let revealedAttr = false;
        if (this.refBoundings.y < 0) this.refBoundings.y += window.scrollY;
        if (this.refBoundings.y < window.scrollY) {
          revealedAttr = true;
        }

        this.setStickyStatus(revealedAttr);
      }

      setStickyStatus(revealed) {
        if (this.dataset.hideOnEnd === "true") {
          if (window.innerHeight + window.scrollY >= this.endBounds) {
            this.stickyHide();
            return;
          }
        }

        if (revealed) {
          this.setAttribute("data-revealed", true);
          if (this.dataset.hasHidden === "true")
            this.removeAttribute("aria-hidden");
          if (this.dataset.bodyClass)
            document.body.classList.add(this.dataset.bodyClass);
          if (this.height) {
            this.style.height = this.height + "px";
            if (this.dataset.bodyClass)
              document.body.style.setProperty(
                "--page-header-height",
                this.height + "px"
              );
          }
          return;
        }

        this.stickyHide();
      }

      stickyHide() {
        this.setAttribute("data-revealed", false);
        if (this.dataset.hasHidden === "true")
          this.setAttribute("aria-hidden", true);
        if (this.dataset.bodyClass)
          document.body.classList.remove(this.dataset.bodyClass);
        if (this.height) {
          this.style.removeProperty("height");

          if (this.dataset.bodyClass)
            document.body.style.removeProperty("--page-header-height");
        }
      }

      dropdownClose() {
        const dropdowns = this.querySelectorAll("dropdown-component");
        if (!dropdowns) return;
        dropdowns.forEach((dropdown) => {
          dropdown.close();
        });
      }
    }
  );
}

if (!customElements.get("product-card-compare-remove")) {
  customElements.define(
    "product-card-compare-remove",
    class ProductCardCompareRemove extends HTMLElement {
      constructor() {
        super();

        this.btn = this.querySelector("a")
          ? this.querySelector("a")
          : this.querySelector("button");
        if (this.btn)
          this.btn.addEventListener("click", this.onCompareRemoval.bind(this));
      }

      onCompareRemoval() {
        event.preventDefault();

        const compareBtns = document.querySelectorAll("product-compare-button");
        const compareListStorage = localStorage.getItem("comparelist");
        const comparelistContainer = document.querySelector(
          '[data-modal-main="compare"]'
        );
        const comparelistOrganizer = document.querySelector(".compare-counter");
        const modalCompare = document.querySelector(
          '[data-modal][data-compare="true"]'
        );
        let compareList = compareListStorage
          ? JSON.parse(compareListStorage)
          : [];
        var index = compareList.indexOf(this.dataset.handle);

        if (index !== -1) {
          compareList.splice(index, 1);
        }
        localStorage.setItem("comparelist", JSON.stringify(compareList));
        if (modalCompare) modalCompare.close();

        // const parentColumn = this.btn.closest('.compare-product');
        // if(parentColumn) parentColumn.parentElement.remove();

        if (comparelistContainer.classList.contains("--limit-exceed"))
          comparelistContainer.classList.remove("--limit-exceed");
        const modalOpener = document.querySelector(
          '[data-modal-main="compare"]'
        );
        if (compareList.length === 0) {
          modalOpener.classList.add("hidden");
          const modal = document.querySelector(
            '[data-modal="modal-compare-show"]'
          );
          if (modal) modal.close();
        } else if (compareList.length === 1) {
          modalOpener.classList.remove("hidden");
          modalOpener.classList.add("--disabled");
        } else {
          modalOpener.classList.remove("--disabled");
          modalOpener.classList.remove("hidden");
        }
        if (comparelistOrganizer) {
          comparelistOrganizer.innerText = compareList.length;
        }
        if (compareBtns) {
          compareBtns.forEach((btn) => {
            if (
              btn.dataset.handle == this.dataset.handle &&
              btn.anchor.classList.contains("--compare-active")
            )
              btn.anchor.classList.remove("--compare-active");
          });
        }
        if (compareList.length !== 0 && modalCompare) modalCompare.open();
      }
    }
  );
}
if (!customElements.get("product-recommendations")) {
  customElements.define(
    "product-recommendations",
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        this.bundleContainer = document.querySelector("bundle-product-wrapper");
      }

      connectedCallback() {
        this.empty = true;

        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);

          fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
              const html = document.createElement("div");
              html.innerHTML = text;
              const recommendations = html.querySelector(
                ".product-recommendations"
              );

              if (recommendations && recommendations.innerHTML.trim().length) {
                this.empty = false;
                this.innerHTML = recommendations.innerHTML;

                if (!recommendations.innerHTML.includes("<product-card")) {
                  let recommendationAncestor = this.parentElement;

                  while (
                    recommendationAncestor &&
                    !recommendationAncestor.classList.contains("recommendation")
                  ) {
                    recommendationAncestor =
                      recommendationAncestor.parentElement;
                  }

                  if (recommendationAncestor) {
                    recommendationAncestor.classList.add("hidden");
                  }
                }
              } else {
                if (this.bundleContainer)
                  this.bundleContainer.classList.add("hidden");
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              if (this.bundleContainer) this.bundleContainer.initBundleCheck();
              if (this.empty) this.parentElement.classList.add("hidden");
            });
        };

        new IntersectionObserver(handleIntersection.bind(this), {
          rootMargin: "0px 0px 400px 0px",
        }).observe(this);
      }
    }
  );
}

// marquee
if (!customElements.get("marquee-component")) {
  customElements.define(
    "marquee-component",
    class MarqueeComponent extends HTMLElement {
      constructor() {
        super();

        if (this.dataset.pauseOnHover === "true") {
          this.addEventListener("mouseenter", this.setOnPause.bind(this));
          this.addEventListener("mouseleave", this.setOnResume.bind(this));
        }

        this.onLoad = setTimeout(this.initialize.bind(this), 2000);
      }

      connectedCallback() {
        this.columnsCount = this.querySelectorAll(
          '.marquee-component_col:not([class*="cloned"])'
        ).length;
        document.addEventListener("DOMContentLoaded", function () {
          this.onload;
        });
      }

      initialize() {
        this.init = null;
        this.initBounds = this.getColumnsSize() * 2;
        this.mainBounds = this.dataset.rotation
          ? this.getBoundingClientRect().height
          : this.getBoundingClientRect().width;
        this.createClones();
        this.dataset.direction === "forward"
          ? this.setOnMarquee(this.initBounds * -1, this.initBounds)
          : this.setOnMarquee(0, this.initBounds);
      }

      setOnMarquee(pos, cycle) {
        const speed = parseFloat(this.dataset.speed);
        let cycleCount = cycle;
        let container = this.querySelector(".marquee-component");
        clearInterval(this.init);
        this.init = setInterval(frame.bind(this), speed);

        function frame() {
          if (cycleCount <= 1) {
            clearInterval(this.init);
            if (this.dataset.rotation) {
              container.style.top = 0 + "px";
            } else {
              container.style.left = 0 + "px";
            }
            this.dataset.direction === "forward"
              ? this.setOnMarquee(this.initBounds * -1, this.initBounds)
              : this.setOnMarquee(0, this.initBounds);
            this.pos = pos;
          } else {
            this.dataset.direction === "forward" ? pos++ : pos--;
            cycleCount--;
            this.pos = pos;
            this.cycleCount = cycleCount;

            if (this.dataset.rotation) {
              container.style.top = pos + "px";
            } else {
              container.style.left = pos + "px";
            }
          }
        }
      }

      setOnPause() {
        clearInterval(this.init);
      }

      setOnResume() {
        this.setOnMarquee(this.pos, this.cycleCount);
      }

      setContainer(size, container) {
        if (this.dataset.rotation) {
          container.style.height = size + "px";
          container.style.top = this.initBounds * -1 + "px";
        } else {
          container.style.width = size + "px";
          container.style.left = this.initBounds * -1 + "px";
        }
      }

      setTabIndexing() {
        const focusables = this.querySelectorAll(
          '[class*="cloned"] a',
          '[class*="cloned"] button'
        );
        focusables.forEach((element) => {
          element.tabIndex = -1;
          element.setAttribute("aria-hidden", "true");
        });
      }

      createClones() {
        const wrapper = this.querySelector(".marquee-component");
        this.sizes = this.getColumnsSize();
        this.clone(wrapper);

        while (this.sizes < this.mainBounds) {
          this.clone(wrapper);
          this.createClones();
        }
        this.setContainer(this.sizes, wrapper);
        this.setTabIndexing();
      }

      clone(wrapper) {
        const columns = this.querySelectorAll(
          '.marquee-component_col:not([class*="cloned"])'
        );
        for (const column of columns) {
          const clonedColumn = column.cloneNode(true);
          clonedColumn.classList.add("clonedBefore");
          wrapper.insertBefore(clonedColumn, columns[0]);
        }
        for (const column of columns) {
          const clonedColumn = column.cloneNode(true);
          clonedColumn.classList.add("clonedAfter");
          wrapper.appendChild(clonedColumn);
        }
      }

      getColumnsSize() {
        let widths = 0;
        const columns = this.querySelectorAll(".marquee-component_col");
        columns.forEach((column) => {
          const bounds = column.getBoundingClientRect();
          widths += this.dataset.rotation ? bounds.height : bounds.width;
        });

        return widths;
      }
    }
  );
}

// button dropdown component
if (!customElements.get("dropdown-component")) {
  customElements.define(
    "dropdown-component",
    class DropdownComponent extends HTMLElement {
      constructor() {
        super();

        if (this.dataset.desktopHidden === "true" && screen.width > 767) return;
        this.button = this.querySelector(
          ".dropdown-component_opener:not(.hidden)"
        );
        this.content = this.querySelector(".dropdown-component_wrapper");
        this.onButtonClick = this.toggleDropdown.bind(this);
        this.shareEvent = this.copyToClipboard.bind(this);
        this.shareClose = this.close.bind(this);
        this.onBodyClick = this.onBodyClick.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.button.addEventListener("click", this.onButtonClick);

        if (this.dataset.submission === "true") {
          this.input = this.querySelector("input");
          const itemsArr = this.content.querySelectorAll(
            ".dropdown-component_btn-submit"
          );
          if (!itemsArr) return;
          itemsArr.forEach((item) => {
            item.addEventListener("click", this.onItemClick.bind(this));
          });
        }

        if (this.dataset.sorting === "true") {
          const itemsArr = this.content.querySelectorAll(
            ".dropdown-component_btn-sort"
          );
          if (!itemsArr) return;
          itemsArr.forEach((item) => {
            item.addEventListener("click", this.onSort.bind(this));
          });
        }

        if (this.dataset.share === "true") {
          this.elements = {
            successMessage: this.querySelector(".shareMessage"),
            closeButton: this.querySelector(".share-button__close"),
            shareButton: this.querySelector(".share-button__copy"),
            urlInput: this.querySelector(".shareUrl"),
          };
          if (navigator.share) {
            this.button.removeEventListener("click", this.onButtonClick);
            this.button.addEventListener("click", () => {
              navigator.share({
                url: this.elements.urlInput.value,
                title: document.title,
              });
            });
            return;
          }
        }

        this.setIndexing(false);
      }

      toggleDetails() {
        if (!this.dataset.share) return;
        this.elements.successMessage.classList.add("hidden");
        this.elements.successMessage.textContent = "";
        this.elements.closeButton.classList.add("hidden");
      }

      copyToClipboard() {
        if (!this.dataset.share) return;
        navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
          this.elements.successMessage.classList.remove("hidden");
          this.elements.successMessage.textContent =
            window.accessibilityStrings.shareSuccess;
          this.elements.closeButton.classList.remove("hidden");
        });
        this.elements.closeButton.addEventListener("click", this.shareClose);
      }

      open() {
        this.button.setAttribute("aria-expanded", true);
        this.content.focus();
        this.content.classList.add("dropdown--open");
        const focusables =
          this.dataset.dropdownLevel === "2"
            ? this.querySelectorAll('a[data-level="2"],button[data-level="2"]')
            : this.querySelectorAll('a[data-level="1"],button[data-level="1"]');
        document.body.addEventListener("click", this.onBodyClick);
        this.addEventListener("keyup", this.onKeyUp);
        if (this.dataset.share === "true") {
          if (!navigator.share) {
            this.elements.shareButton.addEventListener(
              "click",
              this.shareEvent
            );
          }
        }
        if (!focusables) return;
        this.setIndexing(true, focusables);
      }

      close() {
        this.button.setAttribute("aria-expanded", false);
        this.content.classList.remove("dropdown--open");
        document.body.removeEventListener("click", this.onBodyClick);
        this.removeEventListener("keyup", this.onKeyUp);
        if (this.dataset.share === "true") {
          if (navigator.share) {
            this.elements.shareButton.removeEventListener("click", () => {
              navigator.share();
            });
          } else {
            this.elements.shareButton.removeEventListener(
              "click",
              this.shareEvent
            );
          }
          this.toggleDetails();
        }
        const focusables =
          this.dataset.dropdownLevel === "2"
            ? this.querySelectorAll('a[data-level="2"],button[data-level="2"]')
            : this.querySelectorAll('a[data-level="1"],button[data-level="1"]');
        if (!focusables) return;
        this.setIndexing(false, focusables);
      }

      toggleDropdown(event) {
        if (event.target.getAttribute("aria-expanded") === "true")
          return this.close();
        this.open();
      }

      onBodyClick(event) {
        const target = event.target;
        if (
          this.contains(target) ||
          target === this ||
          (target === this.button &&
            this.button.getAttribute("aria-expanded") === "true")
        )
          return;

        if (this.dataset.dropdownLevel === "2") {
          event.stopPropagation();
          this.close();
          return;
        }

        this.close();
      }

      onKeyUp(event) {
        if (event.code.toUpperCase() !== "ESCAPE") return;

        if (this.dataset.dropdownLevel === "2") {
          event.stopPropagation();
          this.close();
          return;
        }
        this.close();
        this.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        const form = document.getElementById(this.dataset.formId);
        if (this.input) this.input.value = event.currentTarget.dataset.value;
        if (this.input && form) form.submit();
      }

      onSort(event) {
        event.preventDefault();
        const sortInput = document.getElementById(this.dataset.inputId);
        let form = document.querySelector(".filters-sidebar filters-form form");
        if (!form) form = document.querySelector("#filters-form");
        if (!sortInput || !form) return;
        const value = event.target.dataset.value;
        const text = event.target.firstChild.textContent;
        this.button.firstChild.textContent = text;
        sortInput.value = value;
        form.dispatchEvent(new Event("input"));
      }

      setIndexing(flag, arr = null) {
        const focusables = arr
          ? arr
          : this.content.querySelectorAll("a[data-level],button[data-level]");
        if (!focusables) return;
        focusables.forEach((element) => {
          indexing(flag, element);
        });

        function indexing(condition, element) {
          if (condition) {
            element.removeAttribute("tabindex");
          } else {
            element.setAttribute("tabindex", "-1");
          }
        }
      }
    }
  );
}

// modal / drawer toggler
if (!customElements.get("modal-component-toggler")) {
  customElements.define(
    "modal-component-toggler",
    class ModalComponentToggler extends HTMLElement {
      constructor() {
        super();

        if (this.dataset.desktopHidden && screen.width > 991) return;
        if (this.dataset.mobileHidden && screen.width < 768) return;
        this.button = this.querySelector("button");
        this.button.addEventListener("click", this.toggleModal.bind(this));
      }

      open(modal) {
        modal.open(this.button);
        window.dispatchEvent(new Event('resize'));
        this.button.setAttribute("data-expanded", "true");
      }

      close(modal) {
        modal.close();
        window.dispatchEvent(new Event('resize'));
      }

      toggleModal(event) {
        event.preventDefault();

        // Specifically checking if serial number lookup modal is active while another modal toggle is activated. We could generalize this by
        // checking if data-expanded == false && currently active modal, but I don't want to screw up anything else on the site in case concurrent
        // modals are allowed elsewhere.
        if (
          this.button.dataset.modalRef != "modal-serial-lookup" &&
          document.body.classList.contains("modal-serial-lookup--modal-active")
        ) {
          const serialNumberModal = document.querySelector(
            '[data-modal="modal-serial-lookup"]'
          );
          this.close(serialNumberModal);
        }

        const modal = document.querySelector(
          `[data-modal="${this.button.dataset.modalRef}"]`
        );

        //This condition was added to let some toggles remain open Ex: serial number look up search.
        if (
          this.button.classList.contains("open-only") &&
          document.body.classList.contains("modal-serial-lookup--modal-active")
        ) {
          return;
        }

        //End remain open additional feature.
        if (this.button.dataset.expanded === "true") return this.close(modal);
        this.open(modal);
      }
    }
  );
}

// modal / drawer content component
if (!customElements.get("modal-component")) {
  customElements.define(
    "modal-component",
    class ModalComponent extends HTMLElement {
      constructor() {
        super();

        if (this.dataset.desktopHidden && screen.width > 991) return;
        if (this.dataset.mobileHidden && screen.width < 768) return;
        this.toggler = null;
        this.parent = null;
        this.content = this.querySelector(".modal-component");
        this.onKeyUp = this.onKeyUp.bind(this);
        this.onBodyClick = this.onBodyClick.bind(this);

        if (this.dataset.compare === "true") {
          this.elements = {
            counterElement: this.querySelector(".compare-counter"),
            contentBody: this.querySelector(".compare-popup_body"),
            contentGrid: this.querySelector(".compare-popup_grid"),
          };
        }
      }

      open(toggler = null) {
        this.toggler = toggler;
        if (this.dataset.container === "body") {
          this.parent = this.parentElement;
          document.body.append(this);
        }
        this.setClasses(true);
        if (this.dataset.compare === "true") {
          this.onContentOpen();
        } else {
          this.content.focus();
          trapFocus(this.content);
        }
        this.setListeners(true);
      }

      close() {
        if (this.dataset.container === "body") {
          if (this.parentNode === document.body)
            document.body.removeChild(this);
          if (this.parent) this.parent.append(this);
        }
        if (this.toggler) this.toggler.setAttribute("data-expanded", "false");
        this.setClasses(false);
        if (this.toggler) removeTrapFocus(this.toggler);
        this.toggler = null;
        this.parent = null;
        this.setListeners(false);
        if (this.dataset.formReset === "true") {
          const form = this.querySelector("form");
          if (form) form.reset();
        }
      }

      setClasses(flag) {
        if (!flag) {
          this.classList.remove("modal--active");
          document.body.classList.remove(
            `${this.dataset.modal}--modal-active`,
            "overflow-hidden"
          );
          return;
        }
        this.classList.add("modal--active");
        document.body.classList.add(
          `${this.dataset.modal}--modal-active`,
          "overflow-hidden"
        );
      }

      setListeners(flag) {
        if (flag) {
          this.addEventListener("keyup", this.onKeyUp);
          if (!this.dataset.compare)
            this.addEventListener("click", this.onBodyClick);
        } else {
          this.removeEventListener("keyup", this.onKeyUp);
          if (!this.dataset.compare)
            this.removeEventListener("click", this.onBodyClick);
        }
      }

      onBodyClick(event) {
        const target = event.target;
        const boundings = this.querySelector(".modal-component_body");
        if (boundings.contains(target) || target === boundings) return;
        this.close();
      }

      onKeyUp(event) {
        if (event.code.toUpperCase() !== "ESCAPE") return;
        this.close();
      }

      onContentOpen() {
        this.classList.remove("--loaded");
        this.elements.contentBody.classList.add("--show-loader");
        this.elements.contentGrid.innerHTML = "";
        const compareListStorage = localStorage.getItem("comparelist");
        const compareList = JSON.parse(compareListStorage);
        while (compareList.length < 3) {
          compareList.push("product");
        }
        this.initRenderProcess(compareList);
      }

      initRenderProcess(arr) {
        if (arr.length) {
          const columnCurr = arr[0];
          this.getCompareRender(columnCurr, arr);

          return;
        }
        this.setSameheightRows();

        this.elements.contentBody.classList.remove("--show-loader");
        this.classList.add("--loaded");
        this.content.focus();
        trapFocus(this.content);
      }

      getCompareRender(handle, all) {
        fetch(
          `${this.dataset.url}/products/${handle}/?section_id=${this.dataset.sectionId}`
        )
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            const currHtml = html.querySelector(
              "#compare-product-organizer > div"
            );

            this.setAppendColumn(currHtml);
          })
          .finally(() => {
            this.setCurrentArr(all);
          });
      }

      setAppendColumn(html) {
        this.elements.contentGrid.append(html);
      }

      setCurrentArr(norm) {
        const nextColumnsArr = norm.slice(1);
        this.initRenderProcess(nextColumnsArr);
      }

      setSameheightRows() {
        const rows = this.querySelectorAll(".compare-product_row");
        let height = 0;

        for (let i = 0; i < rows.length; i++) {
          const elementHeight = rows[i].offsetHeight;

          if (elementHeight > height) {
            height = elementHeight;
          }
        }

        for (let i = 0; i < rows.length; i++) {
          rows[i].style.setProperty("--cp-same-height", height + "px");
        }
      }
    }
  );
}

// tabset
if (!customElements.get("tabset-component")) {
  customElements.define(
    "tabset-component",
    class TabsetComponent extends HTMLElement {
      constructor() {
        super();

        this.tablistNode = this;
        this.tabs = Array.from(this.tablistNode.querySelectorAll("[role=tab]"));
        this.initialize();
        if (this.dataset.editorMode === "true") {
          document.addEventListener("shopify:block:select", function (event) {
            const target = event.target;
            const parent = target.parentElement;
            if (parent.nodeName !== "TABSET-COMPONENT") return;
            parent.initialize();
            parent.setSelectedTab(target);
          });
        }
      }

      initialize() {
        this.tabpanels = this.tabs.map((tab) =>
          document.getElementById(tab.getAttribute("aria-controls"))
        );
        this.tabs.forEach((tab) => {
          tab.tabIndex = -1;
          tab.setAttribute("aria-selected", "false");
          tab.addEventListener("keydown", this.onKeydown.bind(this));
          tab.addEventListener("click", this.onClick.bind(this));
        });

        this.firstTab = this.tabs[0];
        this.lastTab = this.tabs[this.tabs.length - 1];
        this.setSelectedTab(this.firstTab, false);
      }

      setSelectedTab(currentTab, setFocus = true) {
        this.tabs.forEach((tab, index) => {
          const isSelected = currentTab === tab;
          tab.setAttribute("aria-selected", isSelected ? "true" : "false");
          tab.tabIndex = isSelected ? 0 : -1;
          this.tabpanels[index].classList.toggle("hidden", !isSelected);
          if (isSelected && setFocus) {
            tab.focus();
          }
        });
      }

      setSelectedToPreviousTab(currentTab) {
        const index = this.tabs.indexOf(currentTab);
        this.setSelectedTab(index === 0 ? this.lastTab : this.tabs[index - 1]);
      }

      setSelectedToNextTab(currentTab) {
        const index = this.tabs.indexOf(currentTab);
        this.setSelectedTab(
          index === this.tabs.length - 1 ? this.firstTab : this.tabs[index + 1]
        );
      }

      onKeydown(event) {
        const tgt = event.currentTarget;
        let flag = false;

        switch (event.key) {
          case "ArrowLeft":
            this.setSelectedToPreviousTab(tgt);
            flag = true;
            break;

          case "ArrowRight":
            this.setSelectedToNextTab(tgt);
            flag = true;
            break;

          case "Home":
            this.setSelectedTab(this.firstTab);
            flag = true;
            break;

          case "End":
            this.setSelectedTab(this.lastTab);
            flag = true;
            break;

          default:
            break;
        }

        if (flag) {
          event.stopPropagation();
          event.preventDefault();
        }
      }

      onClick(event) {
        this.setSelectedTab(event.currentTarget);
      }
    }
  );
}

if (!customElements.get("shipping-bar")) {
  customElements.define(
    "shipping-bar",
    class ShippingBar extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.setString();
        this.setBar();
      }

      setString() {
        const dataRate = Number(this.dataset.amount);
        const rateFactor = Shopify.currency.rate || 1;
        const amountCalc = dataRate * rateFactor;
        const html = this.innerHTML;
        const cartTotals = Number(this.dataset.cartTotals) / 100;
        const amount = (amountCalc - cartTotals) * 100;
        if (amount > 0) {
          this.innerHTML = html.replace(
            /\|\|amount\|\|/g,
            Shopify.formatMoney(amount, window.money_format)
          );
        } else {
          this.firstElementChild.innerHTML = window.cartStrings.shippingAmount;
        }
        this.threshold = amountCalc;
        this.cartTotals = cartTotals;
      }

      setBar() {
        const element = this.querySelector('[data-set="bar"]');
        if (!element) return;
        const percent = (this.cartTotals / this.threshold) * 100;
        element.style.width = percent + "%";
      }
    }
  );
}

if (!customElements.get("search-lookup")) {
  customElements.define(
    "search-lookup",
    class SearchLookup extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.inputElement = this.querySelector('input[type="text"]');
        this.buttonElement = this.querySelector('button[type="submit"]');

        if (this.buttonElement) {
          this.buttonElement.addEventListener(
            "click",
            this.fetchData.bind(this)
          );
        }
      }

      async fetchData(e) {
        e.preventDefault();
        if (!this.inputElement.value) return;

        const $error = $('#lookup-options-search-error');
        $error.html('&nbsp;');

        const query = this.inputElement.value.trim();
        const regex = /^\d{6}(-\d{3})?$/; // Checks that the string is a number and in either xxxxxx or xxxxxx-xxx format

        // Query shopify to get product information
        if (regex.test(query)) {

          const titleFetchUrl = `https://shopifypartidlookup.azurewebsites.net/title/${query}`;
          let returnData = null;

          await $.get(titleFetchUrl)
            .done((data) => {
              if (data.includes("Error")) {
                $error.text('SKU not found');
                console.error(data);
              } else {
                returnData = data;
              }
            })
            .fail((error) => {
              $error.text('SKU not found');
              console.error(error);
            });

          if (returnData) {
            const categoryText = returnData
              .split("-")[0]
              .trim()
              .toLowerCase()
              .replaceAll(" ", "-")
              .replaceAll("/", "-");
            const url = `/products/${categoryText}-part-${query}`;
            window.location.href = url;
          }
        } else {
          const url = `/search?q=${query}`;
          window.location.href = url;
        }
      }
    }
  );
}

if (!customElements.get("serial-lookup")) {
  customElements.define(
    "serial-lookup",
    class SerialLookup extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.inputElement = this.querySelector('input[type="text"]');
        this.buttonElement = this.querySelector(
          "modal-component-toggler > button"
        );
        this.modalElement = this.querySelector("modal-component");
        this.loaderElement = this.modalElement.querySelector(".lookup-loading");
        this.tableElement = this.modalElement.querySelector(".lookup-table");

        if (this.buttonElement) {
          this.buttonElement.addEventListener(
            "click",
            this.fetchData.bind(this)
          );
        }
      }

      fetchData(e) {
        e.preventDefault();
        if (!this.inputElement.value) {
          this.loaderElement.hidden = true;
          this.tableElement.innerHTML = "Please type a serial number";
          return;
        }
        const serialNumber = this.inputElement.value;
        const fetchUrl = `https://api.truemfg.com/api/SerialNumber/${serialNumber}`;
        const resourceUrl =
          "https://www.truemfg.com/wp-json/api-v1/resource_urls";
        let accumulator = {};

        this.loaderElement.hidden = false;
        this.tableElement.innerHTML = "";
        this.modalElement.classList.add("modal--active");

        getBasicSNData(fetchUrl, accumulator)
          .then(() => getCustomerSNData(fetchUrl, accumulator))
          .then(() => getSNResourceData(resourceUrl, accumulator))
          .then(() => displayTable(accumulator, this.tableElement))
          .catch((error) => {
            console.log("Error:", error);
          })
          .finally(() => {
            this.loaderElement.hidden = true;
          });
      }
    }
  );

  if (!customElements.get("model-lookup")) {
    customElements.define(
      "model-lookup",
      class ModelLookup extends HTMLElement {
        constructor() {
          super();
          this.optionsLoaded = false;
          this.previousValue = null;

          this.appendOptions = (htmlString) => {
            const parser = new DOMParser();
            const htmlDocument = parser.parseFromString(
              htmlString,
              "text/html"
            );
            const options = htmlDocument.querySelectorAll("option");

            options.forEach((option) => {
              this.selectElement.appendChild(option.cloneNode(true));
            });

            $(this.selectElement).trigger("change.select2");
          };
        }

        connectedCallback() {
          this.selectElement = this.querySelector("select");
          this.pagination = this.dataset.pagination
            ? JSON.parse(this.dataset.pagination).slice(1)
            : null;

          if (this.selectElement) {
            // Initialize Select2
            $(this.selectElement).select2({ width: "resolve" }); // Load options immediately

            this.loadOptions();

            $(this.selectElement).on(
              "select2:select",
              this.onOptionSelected.bind(this)
            );

            this.selectElement.addEventListener(
              "click",
              this.onDropdownClick.bind(this)
            );
          }
        }


        async loadOptions() {
          // Add a temporary "Loading..." option
          const loadingOption = document.createElement('option');
          loadingOption.textContent = 'Loading...';
          loadingOption.disabled = true;
          loadingOption.selected = true;
          this.selectElement.appendChild(loadingOption);

          const selectModel = document.createElement('option');
          selectModel.textContent = 'Select Model';
          selectModel.selected = true;

          try {
            const response = await fetch('https://shopifypartidlookup.azurewebsites.net/models');
            const models = await response.json();

            // Remove the "Loading..." option
            this.selectElement.removeChild(loadingOption);
            this.selectElement.appendChild(selectModel);

            models.forEach(model => {
              const option = document.createElement('option');
              option.value = `/collections/${model.handle}`;
              option.textContent = model.title;
              this.selectElement.appendChild(option);
            });
          } catch (error) {
            console.error('Failed to load model options:', error);
            loadingOption.textContent = 'Failed to load models';
            loadingOption.disabled = true;
            loadingOption.selected = true;
          }
        }



        onOptionSelected(e) {
          const selectedValue = this.selectElement.value;
          if (selectedValue) {
            window.location.href = selectedValue;
          }
        }

        onDropdownClick(e) {
          const selectedValue = this.selectElement.value;
          if (
            this.hasAttribute("no-placeholder") &&
            selectedValue &&
            selectedValue === this.previousValue
          ) {
            window.location.href = selectedValue;
          }
          this.previousValue = selectedValue;
        }
      }
    );
  }

  if (!customElements.get("get-parts-comments")) {
    customElements.define(
      "get-parts-comments",
      class GetPartsComments extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.dropdown = this.querySelector("select");

          this.accordions = document.querySelectorAll(
            ".main-product_collapsible_row-block"
          );
          this.notesContainer = Array.from(this.accordions).find((element) =>
            element.textContent.includes("Model specific notes")
          );
          if (!!this.notesContainer) {
            this.noteElm = this.notesContainer.querySelector(
              ".collapsible-row_content"
            );
          }

          this.fetchData();
          if (!!this.dropdown) {
            this.dropdown.addEventListener("change", this.fetchData.bind(this));
          }
        }

        fetchData() {
          // https://api.truemfg.com/swagger/index.html
          const partNumber = encodeURIComponent(this.dropdown.value);
          const model = this.dropdown.dataset.sku;
          const fetchUrl = `https://api.truemfg.com/api/Parts/GetPartComments/${model}/${partNumber}/`;
          fetch(fetchUrl, {
            method: "GET",
            headers: {
              Authorization: `Bearer ${atob(
                sessionStorage.getItem("trueMfgToken")
              )}`,
            },
          })
            .then((fetchResponse) => {
              if (!fetchResponse.ok) {
                throw new Error("Fetch failed: " + fetchResponse.statusText);
              }
              return fetchResponse.json();
            })
            .then((data) => {
              if (!!this.noteElm) {
                let allNotes = data.data[0];
                let note = allNotes.partByModelDescription
                  ? `<p> ${allNotes.partByModelDescription}</p>`
                  : "";
                note += allNotes.comments
                  ? `<p> ${allNotes.comments} </p>`
                  : "";
                this.noteElm.innerHTML = note ? note : "<p>No notes found.";
              }
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        }
      }
    );
  }
}

/***** TOPS INTEGRATION - parts-search.liquid section *****/
// The call to our API. Requires an element on the page containing the host url and token.
// The token should be requested on the back end so as not to expose the user name and password of our API.

function getApiData(path) {
  let host = document.querySelector('input[name="true-api-host"]')?.value;
  if (!host) host = "https://api.truemfg.com";
  const token = atob(sessionStorage.getItem("trueMfgToken"));

  return new Promise((resolve, reject) => {
    fetch(host + path, {
      method: "GET",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Origin": "*",
      },
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((errorData) => {
            throw new Error(errorData["data"][0]["error"] || "Data Problem");
          });
        }
        return response.json();
      })
      .then((data) => {
        if (!data["data"][0] || data["data"][0]["error"]) {
          reject("Data Problem");
        } else resolve(data["data"]);
      })
      .catch((error) => reject(error.message));
  });
}

// Dates in JDE are super weird, so we have to convert them sometimes

function dateToJde(d) {
  var d1 = new Date(d.toString());
  d1 = new Date(d1.getTime() + d1.getTimezoneOffset() * 60000);
  var d2 = new Date(d1.getFullYear().toString() + "/01/01"); // point of reference from which to count days
  var j = 0;
  j += 100000 * (Math.floor(d1.getFullYear() / 100) - 19); // century
  j += (d1.getFullYear() % 100) * 1000;
  j += 1 + Math.floor((d1 - d2) / 1000 / 60 / 60 / 24);
  return j;
}

function dateFromJde(j) {
  var jd = parseInt(j, 10);
  var ymd = (
    19000000 +
    Math.floor(jd / 100000) * 1000000 +
    Math.floor((jd % 100000) / 1000) * 10000 +
    101
  ).toString();
  var d = new Date(
    ymd.substring(0, 4) + "/" + ymd.substring(4, 6) + "/" + ymd.substring(6)
  );
  d.setDate(jd % 1000);
  return d;
}

// Asynchronous calls

async function updateTopsSerialData(serialNumberUntrimmed) {
  let serialNumber = serialNumberUntrimmed.trim();
  document
    .querySelectorAll("[data-serial-number]")
    .forEach((el) => (el.textContent = `Serial Number: ${serialNumber}`));
  const host = window.location.hostname;

  const downloadsSpinner = document.querySelector("#tops-spinner-downloads");
  downloadsSpinner.classList.remove("tops-hidden");

  const refrigerantSpinner = document.querySelector(
    "#tops-spinner-refrigerant"
  );
  refrigerantSpinner.classList.remove("tops-hidden");

  try {
    let data = await getApiData(`/serialNumber/${serialNumber}/basic`);
    data = data[0];

    var shipDateElement = document.querySelector("#tops-ship-date-output");
    var modelNumberElement = document.querySelector(
      "#tops-model-number-output"
    );
    var countryElement = document.querySelector(
      "#tops-country-shipped-to-output"
    );
    var refrigerantElement = document.querySelector(
      "#tops-refrigerant-charge-output"
    );
    var downloadsElement = document.querySelector("#tops-downloads");
    if (
      document.querySelector("#tops-work-order-link") &&
      document.querySelector("#tops-sales-order-link")
    ) {
      document.querySelector("#tops-work-order-link").textContent =
        data["woNum"];
      document
        .querySelector("#tops-work-order-link")
        .setAttribute(
          "href",
          `http://ssrsserver.truemfg.com/ReportServer/Pages/ReportViewer.aspx?%2fTOPS%2fSerial+Work+Order&rs:Command=Render&P15Setup=2&Saleable=2&serialNumber=${serialNumber}`
        );
      document.querySelector("#tops-sales-order-link").textContent =
        data["ordNum"];
      document
        .querySelector("#tops-sales-order-link")
        .setAttribute(
          "href",
          `http://ssrsserver.truemfg.com/ReportServer/Pages/ReportViewer.aspx?%2fTOPS%2fSales+Order+Detail&rs:Command=Render&OrdNum=${data["ordNum"]}&OrdTypeCd=${data["ordTypeCd"]}&SalesCoCd=${data["salesCoCd"]}`
        );
    }

    if (data["shipDate"]) {
      const returnDate = new Date(data["shipDate"]);
      shipDateElement.textContent = returnDate.toDateString();
    } else shipDateElement.textContent = "Not Available";

    modelNumberElement.textContent = data["modelNumber"];

    if (data["shipCntry"]) {
      countryElement.textContent = data["shipCntry"];
    } else countryElement.textContent = "Not Applicable";

    let revisionData = await getApiData(`/serialNumber/${data.woNum}/revision`);
    revisionData = revisionData[0];
    getDownloads(revisionData, host, serialNumber);

    if (revisionData.itemNumber && revisionData.revisionNumber) {
      url = `/serialNumber/pmd/${revisionData.itemNumber}/${revisionData.revisionNumber}`;
      let refrigerant = await getApiData(url);

      const oz = refrigerant[0].ounces;
      const kg = refrigerant[0].kg;

      let refrigerantWeight = "";

      if (kg) {
        refrigerantWeight = `${refrigerant[0].refrigerant} / ${refrigerant[0].ounces} Oz; ${refrigerant[0].kg} Kg`;
      } else if (oz.includes("(")) {
        refrigerantWeight = `${refrigerant[0].refrigerant} / ${refrigerant[0].ounces}  Oz(g)`;
      } else {
        refrigerantWeight = `${refrigerant[0].refrigerant} / ${refrigerant[0].ounces}  Oz`;
      }

      refrigerantElement.textContent = refrigerantWeight;
      refrigerantSpinner.classList.add("tops-hidden");
    }
  } catch (e) {
    console.log(e.message);
  } finally {
    enableTopsSearchButtons();

    shipDateElement.classList.add("has-content");
    modelNumberElement.classList.add("has-content");
    countryElement.classList.add("has-content");
    refrigerantElement.classList.add("has-content");
    downloadsElement.classList.add("has-content");

    if (!downloadsSpinner.classList.contains("tops-hidden")) {
      downloadsSpinner.classList.add("tops-hidden");
      const message = document.createElement("p");
      message.innerText = "No Downloads Found";
      message.classList.add("tops-download");
      message.classList.add("results-detail");
      downloadsElement.appendChild(message);
    }

    if (!refrigerantSpinner.classList.contains("tops-hidden")) {
      refrigerantSpinner.classList.add("tops-hidden");
      refrigerantElement.textContent = "No Information Found";
    }
  }
}

async function getDownloads(revisionData, host, serialNumber) {
  const downloadsSpinner = document.querySelector("#tops-spinner-downloads");
  const downloads = document.querySelector("#tops-downloads");

  try {
    if (revisionData["programNumber"] != "") {
      const link = document.createElement("a");
      link.setAttribute(
        "href",
        `https://www.truemfg.com/wp-content/uploads/true-media/tops-programming/${revisionData["programNumber"]}.pdf`
      );
      link.innerText = "Program Numbers";
      link.classList.add("tops-download");
      downloads.appendChild(link);
      downloadsSpinner.classList.add("tops-hidden");
    }

    let bomData = await getApiData(`/serialNumber/${serialNumber}/bom`);
    let wiringPart = "";
    bomData.forEach((element) => {
      if (element.type == "Wiring Diagram") wiringPart = element.itemNum;
    });

    if (wiringPart) {
      const link = document.createElement("a");
      link.setAttribute(
        "href",
        `https://www.truemfg.com/wp-content/uploads/true-media/wiring-diagrams/${wiringPart}.tif`
      );
      link.innerText = "Wiring Diagram";
      link.classList.add("tops-download");
      downloads.appendChild(link);
      downloadsSpinner.classList.add("tops-hidden");
    }
  } catch (e) {
    console.log(e.message);
  }
}

async function updateTopsNavigationDetails(branch, date, itemNumber) {
  const mess = document.querySelector("#tops-drawing-header");
  try {
    mess.innerHTML = `<div id="tops-spinner"></div>`;
    const url = `/Tops/GetTOPSNavigation/${branch}/${itemNumber}/${dateToJde(
      date
    )}`;
    let data = await getApiData(url);
    parseTopsNavigationData(data);
  } catch (e) {
    if (mess) {
      mess.innerText = "No Drawing Found";
      clearDrawing();
      console.log(e.message);
    }
  }
}

async function updateTopsNavigationSerialNumber(serialNumber) {
  const mess = document.querySelector("#tops-drawing-header");
  try {
    mess.innerHTML = `<div id="tops-spinner"</div>`;
    let results = await getApiData(`/Tops/GetTOPSNavigation/${serialNumber}`);
    parseTopsNavigationData(results);
  } catch (e) {
    if (mess) {
      mess.innerText = "No Drawing Found";
      clearDrawing();
      console.log(e.message);
    }
  }
}

async function appendAddToCartButton(element) {
  // Define the properties for the new button (rectangle and text)
  const rectAttributes = {
    x: "90", // Adjust position based on your SVG layout
    y: "168.62", // Same y position as existing elements
    width: "30", // Width of the button
    height: "4.5", // Height of the button
    fill: "#007BFF", // Button color (blue)
    stroke: "#000", // Border color
    "stroke-width": "0.2", // Border thickness
    rx: "15", // Rounded corners
    ry: "15",
  };

  const textAttributes = {
    x: "92", // Text should be inside the button
    y: "171", // Adjust to align with button
    "font-size": "2.5", // Smaller font to fit inside the button
    fill: "#FFFFFF", // White text
    "font-family": "Arial, sans-serif",
    "text-anchor": "start", // Left-align text
    opacity: "1.00",
  };

  // Create <rect> element for the button
  const buttonRect = document.createElementNS(
    "http://www.w3.org/2000/svg",
    "rect"
  );
  Object.entries(rectAttributes).forEach(([key, value]) =>
    buttonRect.setAttribute(key, value)
  );

  // Create <text> element for the button label
  const buttonText = document.createElementNS(
    "http://www.w3.org/2000/svg",
    "text"
  );
  Object.entries(textAttributes).forEach(([key, value]) =>
    buttonText.setAttribute(key, value)
  );
  buttonText.textContent = "Add to Cart"; // Button label

  // Append the button rectangle and text to the existing group
  element.appendChild(buttonRect);
}

async function decompressGzip(base64Data) {
  // Convert base64 string to Uint8Array
  let binaryString = atob(base64Data);
  let byteArray = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    byteArray[i] = binaryString.charCodeAt(i);
  }

  // Use built-in DecompressionStream API
  const decompressionStream = new DecompressionStream("gzip");
  const decompressedStream = new Response(
    new Blob([byteArray]).stream().pipeThrough(decompressionStream)
  );

  return await decompressedStream.text();
}

async function appendDrawing(drawingId) {
  const mess = document.querySelector("#tops-drawing-header");
  try {
    let data = await getApiData(`/Tops/GetTOPSDrawing/${drawingId}`);

    let drawingCompressed = data[0]["drawingDetailCompress"];

    // Decompress gzip
    let drawing = await decompressGzip(drawingCompressed);

    const drawingContainerInner = document.createElement("div");
    drawingContainerInner.setAttribute("data-drawing-id", drawingId);
    drawingContainerInner.innerHTML = drawing;
    drawingContainerInner.innerHTML = drawing.replace(
      'height="auto"',
      'height="100%"'
    );
    var drawingSvg = drawingContainerInner.querySelector("svg");

    const drawingContainer = document.querySelector("#tops-drawing");
    drawingContainer.appendChild(drawingContainerInner);
    drawingContainer.classList.remove("tops-loading");
    await renderTable(data[0].partDataJson);
  } catch (e) {
    if (mess) {
      mess.innerText = "No Drawing Found";
      clearDrawing();
      console.log(e.message);
    }
  }

  // addAtcButtons()

  //stylePartsTable();
}

// Add table event listeners
function tableHoverEvents() {
  let $tableRows = document.querySelectorAll(".part-row");

  $tableRows.forEach((el) =>
    el.addEventListener("mouseover", (e) => {
      e.stopPropagation();
      $rowId = e.currentTarget.getAttribute("hotspotids");
      $drawingId = document
        .querySelector("div[data-drawing-id]")
        .getAttribute("data-drawing-id");
      ShowHotSpot(e, $rowId, $drawingId);
    })
  );

  $tableRows.forEach((el) =>
    el.addEventListener("mouseout", (e) => {
      e.stopPropagation();
      $rowId = e.currentTarget.getAttribute("hotspotids");
      $drawingId = document
        .querySelector("div[data-drawing-id]")
        .getAttribute("data-drawing-id");
      HideHotSpot(e, $rowId, $drawingId);
    })
  );
}

// Remove existing listeners when new drawing is loaded.
function removeTableListeners() {
  let $tableRows = document.querySelectorAll(".part-row");
  // remove all current listeners to prevent memory leaks
  $tableRows.forEach((el) => el.removeEventListener("mouseover", (e) => { }));
  $tableRows.forEach((el) => el.removeEventListener("mouseout", (e) => { }));
}

// Render table of parts
async function renderTable(data) {
  // Contruct New Dynamic Table
  let $svg = document.querySelector(".TOPSDrawingSVG");
  let $partTable = document.querySelector("#paperID").nextElementSibling;
  let $tableCheck = $partTable.getAttribute("id");
  let $tableRows = $partTable.children;
  let $tablenum = 0;
  let $tableHtml = "";
  let $totalHtml = "";
  let $tableDiv = document.querySelector("#parts-table");
  let $postionData =
    (($partTable.getBoundingClientRect().top -
      $svg.getBoundingClientRect().top) /
      $svg.getBoundingClientRect().height) *
    100;
  let $gIndex = 1;
  let $negMargin = 95.75 - Math.ceil($postionData); // Calculate negative top margin to cover svg tables

  //Table header html
  let $headerRow =
    `<div class="header-row">
    <div class="partNum-col">Part Number</div>
    <div class="desc-col">Description</div>
    <div class="cart-col"></div>
    </div>`;

  // Tables are not displayed unless there is data for tables
  if ($tableCheck == null) {
    $tableDiv.style.marginTop = `-${$negMargin}%`; // set top margin to cover hidden svg tables
    $tableDiv.style.background = "#fff";
    $tableDiv.style.display = "flex";
  } else {
    $tableDiv.style.marginTop = 0; // set top margin to cover hidden svg tables
    $tableDiv.style.background = "transparent";
    $tableDiv.style.display = "none";
  }

  $tableDiv.innerHTML = "";

  // Create tables array
  for (let g = 0; g < $tableRows.length; g++) {
    let $node = $tableRows[g];
    let $hotSpotId = $node.getAttribute("hotspotids"); // check attr of g element

    if ($hotSpotId == null && g == 0) {
      //create first table
      $tableHtml = $headerRow;
    }
    if ($hotSpotId == null && g > 0) {
      // start new table if null group detected
      $totalHtml = `${$totalHtml} <div id=table-${$tablenum} class="table">${$tableHtml}</div>`; // wrap all current table data
      $tableHtml = $headerRow; //reset table html
      $tablenum = $tablenum + 1;
    }

    if ($hotSpotId != null && g <= $tableRows.length) {
      // create table row
      let partNum = data[$gIndex - 1].partNum;
      //let productVariant = await getProductVariant(partNum);

      $tableHtml = `${$tableHtml} 
      <div hotspotids="${$hotSpotId}" onclick="ClickHotSpot(this,'${$hotSpotId}')" class="part-row">
        <div class="partNum-col">${partNum}</div>
        <div class="desc-col">${data[$gIndex - 1].partDescription}</div>
        <div class="cart-col"><div class="tops-spinner" data-set-part-number="${partNum}" aria-label="Loading..."></div></div>
      </div>`;
      $gIndex = $gIndex + 1;
      if (g == $tableRows.length - 1) {
        // if it is the last element append html to container
        $totalHtml = `${$totalHtml} <div id=table-${$tablenum} class="table">${$tableHtml}</div>`;
        $tableDiv.insertAdjacentHTML("beforeend", $totalHtml);
      }
    }
    // Get buy now buttons after table load because it's a little slow.
    document.querySelectorAll('.tops-spinner[data-set-part-number]').forEach(async (spinner) => {
      const partNum = spinner.getAttribute('data-set-part-number');
      const variantId = await getProductVariant(partNum);
      const cartButtonHTML = getCartButton(variantId);
      spinner.outerHTML = cartButtonHTML;
    });

  }
  tableHoverEvents();
}
// Remove drawing data from display
function clearDrawing() {
  document.querySelector("#tops-drawing").innerHTML = "";
  //Clear and hide table container
  document.querySelector("#parts-table").innerHTML = "";
  document.querySelector("#parts-table").style.display = "none";
}

// TODO: Finish this function
function addAtcButtons() {
  // 1. get the product from the storeFront API
  // 2. create an svg element to represent the button
  // 3. append the svg element to the parts table
  // 4. add click event listener to the svg element
  //    - on click, add the product to the cart
  var partsTableItems = document.querySelectorAll('g[id^="Line"]');
  if (partsTableItems.length > 0) {
    partsTableItems.forEach(async (item) => {
      var partNumber = Array.from(item.querySelectorAll("text"))[1]
        ?.textContent;
      if (partNumber) {
        try {
          // fetch product using storeFront API. Part Number === sku
          const product = await getProductBySku(partNumber);
          if (product) {
            console.group("\nParts Table Product: ", partNumber);
            console.groupEnd();
          } else {
            console.group("\nParts Table Product: ", partNumber);
            console.groupEnd();
          }
        } catch (error) {
          console.error("Error fetching product: ", error);
        }
      }
    });
  }
}

function setStyles(elements, styles) {
  Object.entries(styles).forEach(([key, value]) => {
    elements.forEach((el) => (el.style[key] = value));
  });
}

// Function to add padding to SVG table cells
function addPaddingToSvg(svgElement, horizontalPadding, verticalPadding) {
  const textElements = svgElement.querySelectorAll("text");
  const pathElements = svgElement.querySelectorAll("path");

  // Adjust text elements for padding
  textElements.forEach((text) => {
    const currentX = parseFloat(text.getAttribute("x"));
    const currentY = parseFloat(text.getAttribute("y"));

    // Add padding to x and y
    text.setAttribute("x", currentX + horizontalPadding);
    text.setAttribute("y", currentY + verticalPadding);
  });

  // Adjust path elements (if resizing is needed for padding)
  pathElements.forEach((path) => {
    const d = path.getAttribute("d");
    const parts = d.split(/[ ,L]/).map(parseFloat);

    if (parts.length === 8) {
      // Modify only the height if vertical padding is added
      parts[5] += verticalPadding; // Adjust y2
      parts[7] += verticalPadding; // Adjust y4
      path.setAttribute(
        "d",
        `M${parts[0]},${parts[1]}L${parts[2]},${parts[3]}L${parts[4]},${parts[5]}L${parts[6]},${parts[7]}z`
      );
    }
  });
}

function stylePartsTable() {
  const pathSelector =
    'path[style="stroke:#000000;stroke-width:0.353;fill:#f0f0ff"]';

  const tableContainer = document.querySelector(
    `g > g:has(g:not([id]) > ${pathSelector})`
  );
  if (tableContainer) {
    const tableHeadings = tableContainer.querySelectorAll(
      `g:not([id]) > ${pathSelector}`
    );
    const headingTexts = tableContainer.querySelectorAll("g:not([id]) > text");
    const bodyTexts = tableContainer.querySelectorAll('g[id^="Line"] > text');
    const columnDividers = tableContainer.querySelectorAll(
      'path[style="stroke:#000000;stroke-width:0.353"]'
    );
    const evenRows = Array.from(
      tableContainer.querySelectorAll(`g[id^="Line"]`)
    ).filter((g) => {
      const id = g.id;
      return parseInt(id.replace("Line", "")) % 2 === 0;
    });

    const oddRows = Array.from(
      tableContainer.querySelectorAll(`g[id^="Line"]`)
    ).filter((g) => {
      const id = g.id;
      return parseInt(id.replace("Line", "")) % 2 !== 0;
    });

    if (tableHeadings.length > 0) setStyles(tableHeadings, { fill: "#005582" });
    if (headingTexts.length > 0)
      setStyles(headingTexts, {
        fill: "#ffffff",
        "font-family": "var(--font-general-family)",
        padding: ".5rem",
      });
    if (bodyTexts.length > 0)
      setStyles(bodyTexts, { "font-family": "Avenir Next, sans-serif" });
    if (columnDividers.length > 0)
      setStyles(columnDividers, { stroke: "transparent" });
    if (evenRows.length > 0 && oddRows.length > 0) {
      setStyles(
        evenRows.map((row) => {
          var path = row.querySelector(
            'path[style*="stroke:#000000;stroke-width:0.353;"]'
          );
          if (path) return path;
        }),
        { fill: "#F4F4F4" }
      );
      setStyles(
        oddRows.map((row) => {
          var path = row.querySelector(
            'path[style*="stroke:#000000;stroke-width:0.353;"]'
          );
          if (path) return path;
        }),
        { fill: "#FFFFFF" }
      );
    }

    // addPaddingToSvg(tableContainer, 5, 5)
  }
}

// Front end updates

function disableTopsSearchButtons() {
  document.querySelector(".lookup")?.classList.add("loading");
  document.querySelector(".lookup")?.setAttribute("disabled", true);
}

function enableTopsSearchButtons() {
  document.querySelector(".lookup")?.removeClass("loading");
  document.querySelector(".lookup")?.setAttribute("disabled", false);
}

function clearTopsSearchResults() {
  document.querySelector("#tops-ship-date-output").innerText = "";
  document.querySelector("#tops-model-number-output").innerText = "";
  document.querySelector("#tops-country-shipped-to-output").innerText = "";
  document.querySelector("#tops-refrigerant-charge-output").innerText = "";
  document.querySelector("#nav-serial-number").innerText = "";
  document.querySelector("#top-level").innerText = "";
  document.querySelector("#tops-nav-menu")?.remove();
  document.querySelector(".tops-download")?.remove();
  clearDrawing();
  document.querySelector("#tops-drawing-header").innerHTML = "";
  if (
    document.querySelector("#tops-work-order-link") &&
    document.querySelector("#tops-sales-order-link")
  ) {
    document.querySelector("#tops-work-order-link").href = "#";
    document.querySelector("#tops-work-order-link").innerText = "";
    document.querySelector("#tops-sales-order-link").href = "#";
    document.querySelector("#tops-sales-order-link").innerText = "";
  }
}

// This can be more concise, but I can't figure it out now. Refactor this.
function ShowHotSpot(event, hotspot, drawingID = null) {
  if (drawingID === null) {
    const currentDrawing = event.currentTarget.closest("div");
    // Dots in ids are no longer permitted, so I have to get the element this way. You can use getElementById, but not here.
    currentDrawing.querySelector(
      `[id = "hotspot.${hotspot}"]`
    ).style.opacity = 0.5;
    const menuItem = document.querySelector(
      `li[data-drawing-position = "${currentDrawing.dataset.drawingId}-${hotspot}"]`
    );
    if (menuItem) menuItem.classList.add("tops-hot-spot-hover");
    const tableItem = document.querySelector(`div[hotspotids = "${hotspot}"]`);
    if (tableItem) tableItem.classList.add("tops-hot-spot-hover");
  } else {
    const hotspotElementExists = document.getElementById("hotspot." + hotspot);
    let hotspotDrawingIdVariable;
    if (hotspotElementExists) {
      hotspotDrawingIdVariable = document
        .getElementById("hotspot." + hotspot)
        .closest("div").dataset.drawingId;
    }
    const hotspotDrawingId = hotspotDrawingIdVariable;
    if (drawingID == hotspotDrawingId) {
      document.getElementById("hotspot." + hotspot).style.opacity = 0.5;
      const menuItem = document.querySelector(
        `li[data-drawing-position = "${drawingID}-${hotspot}"]`
      );
      if (menuItem) menuItem.classList.add("tops-hot-spot-hover");
      const tableItem = document.querySelector(
        `div[hotspotids = "${hotspot}"]`
      );
      if (tableItem) tableItem.classList.add("tops-hot-spot-hover");
    }
  }
}

function parseTopsNavigationData(results) {
  const menu = document.createElement("ul");
  menu.id = "tops-nav-menu";
  let innerList = document.createElement("ul");
  innerList.classList += "inner-list";

  //Create the top level list
  let navElement = document.createElement("li");
  navElement = makeNavElement(results[0], -1);
  navElement.classList.add("tops-selected-nav");
  document.querySelector("#top-level").appendChild(navElement);

  // Set the Nav Header
  document.querySelector("#tops-drawing-header").textContent =
    results[0]["hotSpotName"];

  let outerCount = 0;
  let innerCount = 0;

  for (let i = 1; i < results.length; i++) {
    const resultsData = results[i];

    // Look for an existing element. Some elements have multiple drawings.
    const usableHotSpot = resultsData["formatHotSpot"].replace(".", "-");
    const currentElement =
      menu.querySelector("#menu-item_" + usableHotSpot) ??
      innerList.querySelector("#menu-item_" + usableHotSpot);
    if (currentElement) {
      updateNavElement(currentElement, resultsData, outerCount);
    } else {
      let isTopLevelNavigation = resultsData["parentHotSpot"] == 0;
      if (isTopLevelNavigation) {
        appendInnerList(menu, innerList);
        innerList = getNewInnerList();

        navElement = makeNavElement(resultsData, outerCount++);
        innerCount = 0;
        menu.appendChild(navElement);
      } else {
        navElement = makeNavElement(resultsData, innerCount++);
        innerList.appendChild(navElement);
      }
    }
  }
  let topsNavList = document.querySelector("#tops-nav-list");
  topsNavList.appendChild(menu);

  setNavListEventListeners(topsNavList);

  appendDrawing(results[0]["drawingID"]);
  appendInnerList(menu, innerList);
}

function setNavListEventListeners(element) {
  // Helper function to manage event listeners dynamically
  const manageListener = (eventName, action, handler) => {
    element[action](eventName, handler);
  };

  const desktopHandlers = {
    mouseEnter: () => element.classList.add("tops-nav-hover"),
    mouseLeave: () => element.classList.remove("tops-nav-hover"),
  };

  const mobileHandler = () => element.classList.toggle("tops-nav-hover");

  const addDesktopListeners = () => {
    manageListener(
      "mouseenter",
      "addEventListener",
      desktopHandlers.mouseEnter
    );
    manageListener(
      "mouseleave",
      "addEventListener",
      desktopHandlers.mouseLeave
    );
    element.hasDesktopListener = true;
  };

  const removeDesktopListeners = () => {
    manageListener(
      "mouseenter",
      "removeEventListener",
      desktopHandlers.mouseEnter
    );
    manageListener(
      "mouseleave",
      "removeEventListener",
      desktopHandlers.mouseLeave
    );
    element.classList.remove("tops-nav-hover"); // Explicitly remove the class
    element.hasDesktopListener = false;
  };

  const addMobileListener = () => {
    manageListener("click", "addEventListener", mobileHandler);
    element.hasMobileListener = true;
  };

  const removeMobileListener = () => {
    manageListener("click", "removeEventListener", mobileHandler);
    element.classList.remove("tops-nav-hover"); // Explicitly remove the class
    element.hasMobileListener = false;
  };

  const handleScreenResize = () => {
    const screenWidth = window.innerWidth;

    if (screenWidth < 1024) {
      if (!element.hasMobileListener) {
        removeDesktopListeners();
        addMobileListener();
      }
    } else {
      if (!element.hasDesktopListener) {
        removeMobileListener();
        addDesktopListeners();
      }
    }
  };

  // Initial setup based on the current screen width
  if (window.innerWidth < 1024) addMobileListener();
  else addDesktopListeners();

  // Update listeners on screen resize
  window.addEventListener("resize", handleScreenResize);
}

function appendInnerList(menu, innerList) {
  if (innerList.childNodes.length > 0) {
    menu.appendChild(innerList);
  }
}

function getNewInnerList() {
  innerList = document.createElement("ul");
  innerList.classList += "inner-list";
  return innerList;
}

function makeNavElement(resultsData, menuPosition) {
  navElement = document.createElement(menuPosition !== -1 ? "li" : "span");
  const usableHotSpot = resultsData["formatHotSpot"].replace(".", "-");
  navElement.id = `menu-item_${usableHotSpot}`;

  if (resultsData["drawingID"] != null) {
    navElement.addEventListener("click", topsNavElementClick);
    navElement.setAttribute("data-drawing-id", `${resultsData["drawingID"]}`);
  }

  navElement.addEventListener("mouseover", () => {
    ShowHotSpot("none", menuPosition, resultsData["sourceDrawingID"]);
  });
  navElement.addEventListener("mouseout", () => {
    HideHotSpot("none", menuPosition, resultsData["sourceDrawingID"]);
  });
  navElement.innerText = resultsData["hotSpotName"];

  navElement.setAttribute(
    "data-drawing-position",
    `${resultsData["sourceDrawingID"]}-${menuPosition}`
  );
  return navElement;
}
// Event functions

function ClickHotSpot(event, hotspot) {
  const currentDrawing = event.currentTarget.closest("div").dataset.drawingId;
  const menuItem = document.querySelector(
    `li[data-drawing-position = "${currentDrawing}-${hotspot}"]`
  );

  const lineGroups = document.querySelectorAll(
    "g[hotspotids = '" + hotspot + "']>text.TOPSPowerCordLink"
  );

  if (lineGroups.length > 0) {
    const host = document.querySelector('input[name="true-api-host"]')?.value;
    window.open(
      `https://dc2kentprodcontent.blob.core.windows.net/tops/POWER_CORD_SELECTION_GUIDE.pdf`,
      "_blank"
    );
    lineGroups;
  }
  if (!menuItem || menuItem.dataset.drawingId == "null") return;

  document.querySelector("#tops-drawing-header").innerHTML = "";
  const drawings = menuItem.dataset.drawingId;
  const drawingsToAdd = drawings.split("-");

  if (drawingsToAdd) {
    clearDrawing();
    drawingsToAdd.forEach((drawing) => {
      appendDrawing(drawing);
    });
  }

  const drawingHeader = document.querySelector("#tops-drawing-header");
  if (drawingHeader && menuItem) drawingHeader.textContent = menuItem.innerText;
}

function HideHotSpot(event, hotspot, drawingID = null) {
  if (drawingID === null) {
    const currentDrawing = event.currentTarget.closest("div");
    // Dots in ids are no longer permitted, so I have to get the element this way. You can use getElementById, but not here.
    currentDrawing.querySelector(
      `[id = "hotspot.${hotspot}"]`
    ).style.opacity = 0;
    const menuItem = document.querySelector(
      `li[data-drawing-position = "${currentDrawing.dataset.drawingId}-${hotspot}"]`
    );
  } else {
    const currentHotSpot = document.getElementById("hotspot." + hotspot);
    if (currentHotSpot) currentHotSpot.style.opacity = 0;
  }

  const menuItems = document.querySelectorAll(".tops-hot-spot-hover");
  menuItems.forEach((el) => {
    el.classList.remove("tops-hot-spot-hover");
  });
}

function topsNavElementClick(event) {
  event.preventDefault();
  const elements = document.querySelectorAll(".tops-selected-nav");
  const topLevel = document.querySelector("#tops-nav li#top-level");

  for (var i = 0; i < elements.length; i++) {
    elements[i].classList.remove("tops-selected-nav");
  }

  if (topLevel && window.innerWidth < 1024) {
    const topLevelTextElement = topLevel.querySelector(
      'span[id*="menu-item_"]'
    );
    topLevelTextElement.setAttribute("id", this.getAttribute("id"));
    topLevelTextElement.setAttribute(
      "data-drawing-id",
      this.getAttribute("data-drawing-id")
    );
    topLevelTextElement.setAttribute(
      "data-drawing-position",
      this.getAttribute("data-drawing-position")
    );
    topLevelTextElement.textContent = this.textContent;
    // remove the :hover state from ul#tops-nav-list
  }

  this.classList.add("tops-selected-nav");
  document.querySelector("#tops-drawing-group").classList.add("loading");
  document.querySelector("#tops-drawing-header").textContent = this.innerText;

  const drawings = this.dataset.drawingId;
  const drawingsToAdd = drawings.split("-");

  if (drawingsToAdd) {
    clearDrawing();
    drawingsToAdd.forEach((drawing) => {
      appendDrawing(drawing);
    });
  }
}

// Add event handlers.
document.addEventListener("DOMContentLoaded", function () {
  var serialNumberSearchInput = document.querySelector(
    "#tops-serial-number-input"
  );
  var serialNumberSearchButton = document.querySelector(
    "#tops-serial-number-search"
  );

  var params = new URLSearchParams(window.location.search);
  if (params.get("serial-number")) {
    const serialNumber = params.get("serial-number");
    serialNumberSearchInput.value = serialNumber;
    clearTopsSearchResults();
    disableTopsSearchButtons();
    updateTopsSerialData(serialNumber);
    updateTopsNavigationSerialNumber(serialNumber);
  } else if (serialNumberSearchButton) {
    serialNumberSearchButton.addEventListener("submit", function (e) {
      e.preventDefault();
      clearTopsSearchResults();
      disableTopsSearchButtons();
      const serialNumber = serialNumberSearchInput.value;
      updateTopsSerialData(serialNumber);
      updateTopsNavigationSerialNumber(serialNumber);
    });
  }
});

async function storefrontApiQuery(query) {
  try {
    const response = await fetch(
      `https://4b529e.myshopify.com/api/2024-10/graphql.json`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token":
            "085cfe24124de3d2fe6046121352ad6e",
        },
        body: JSON.stringify({ query }),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    try {
    } catch (error) { }
  }
}

async function getProductBySku(sku) {
  const query = `
		query {
			products(first: 1, query: "sku:${sku}") {
				nodes {
					id
					title
					handle
				}
			}
		}
	`;
  const data = await storefrontApiQuery(query);
  if (!data?.products?.nodes) return null;
  return data.products.nodes[0];
}

function updateNavElement(currentElement, resultsData, outerCount) {
  const currentDrawingList = currentElement.dataset.drawingId;
  if (resultsData["drawingID"] != null) {
    if (currentDrawingList) {
      navElement.setAttribute(
        "data-drawing-id",
        `${currentDrawingList}-${resultsData["drawingID"]}`
      );
    } else {
      navElement.addEventListener("click", topsNavElementClick);
      navElement.setAttribute("data-drawing-id", `${resultsData["drawingID"]}`);
    }
  }
}
/***** TOPS INTEGRATION - parts-search.liquid section *****/

async function updateProductCard(sku, chosenModel) {
  try {
    let data = await getApiData(
      `/api/Parts/GetPartComments/${sku}/${encodeURI(chosenModel)}`
    );
    let note = data[0]["partByModelDescription"]
      ? `<p> ${data[0]["partByModelDescription"]} </p>`
      : "";
    note += data[0]["comments"] ? `<p> ${data[0]["comments"]} <p>` : "";
    document.getElementById(`model-note__${sku}`).innerHTML = note;
  } catch (error) {
    // noop
  } finally {
    document.getElementById(`loading__${sku}`).style.display = "none";
  }
}

// Gets called in filters.js on filter update as well.
function updateSearchResultsShortDescription() {
  const token = sessionStorage.getItem("trueMfgToken");
  const chosenModel = sessionStorage.getItem("chosen-model");
  let sku = false;
  let loadingOverlays = Array.from(
    document.querySelectorAll(".product-card__loading")
  );

  if (chosenModel && loadingOverlays.length && token) {
    loadingOverlays.forEach(async (overlay) => {
      sku = overlay.dataset.sku;
      updateProductCard(sku, chosenModel);
    });
  } else {
    loadingOverlays.forEach((overlay) => (overlay.style.display = "none"));
  }
}

// Immediately call the function
updateSearchResultsShortDescription();

// Toggle for Grid/list view
// Gets called in filters.js on filter update as well.
function saveViewPreference(viewPreference) {
  let daysToExpire = 45;
  let expiryDate = new Date();
  expiryDate.setDate(expiryDate.getDate() + daysToExpire);
  document.cookie =
    "viewPreference =" +
    viewPreference +
    "; expires=" +
    expiryDate.toGMTString() +
    "path=/";
}

function initializeToPreferredView() {
  let preferredView = document.cookie
    .split("; ")
    .find((row) => row.startsWith("viewPreference="))
    ?.split("=")[1];
  if (preferredView == "list") {
    document.querySelector(".grid.filters-grid").classList.add("list-view");
    document.querySelector("#toggle-overlay").classList.add("flip__end-state");

    let selected = document.getElementsByClassName("selected-view");
    Array.from(selected).forEach((e) => e.classList.remove("selected-view"));
    document.querySelector("#list-toggle").classList.add("selected-view");
  }
}

function addToggleEvents(containerSelector) {
  let toggleOverlay = document.querySelector("#toggle-overlay");
  const CSS_ANIMATION_LENGTH = 180;

  containerSelector.addEventListener("click", () => {
    let start = "unflip";
    let end = "flip";
    let results = document.querySelector(".grid.filters-grid");
    let selected = document.getElementsByClassName("selected-view");

    Array.from(selected).forEach((e) => e.classList.remove("selected-view"));

    if (toggleOverlay.classList.contains("flip__end-state")) {
      start = "flip";
      end = "unflip";
      document.querySelector("#grid-toggle").classList.add("selected-view");
      results.classList.remove("list-view");
      saveViewPreference("grid");
    } else {
      document.querySelector("#list-toggle").classList.add("selected-view");
      start = "unflip";
      end = "flip";
      results.classList.add("list-view");
      saveViewPreference("list");
    }

    toggleOverlay.classList.add(`${end}__in-progress`);
    setTimeout(() => {
      toggleOverlay.classList.remove(`${start}__end-state`);
      toggleOverlay.classList.add(`${end}__end-state`);
      toggleOverlay.classList.remove(`${end}__in-progress`);
    }, CSS_ANIMATION_LENGTH);
  });
}

let containerSelector = document.querySelector("#view-toggle__container");
if (containerSelector) {
  initializeToPreferredView();
  addToggleEvents(containerSelector);
}

// SNI functions

function getBasicSNData(fetchUrl, accumulator) {
  return fetch(`${fetchUrl}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${atob(sessionStorage.getItem("trueMfgToken"))}`,
    },
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(
          `Error fetching basic serial number data: ${response.statusText}`
        );
      }
      return response.json();
    })
    .then((response) => {
      Object.assign(accumulator, response.data[0]);
    })
    .catch((error) => {
      console.log("Error fetching basic serial number data:", error);
    });
}

function getCustomerSNData(fetchUrl, accumulator) {
  const requestBody = {
    shopifyGID: `${__st.cid}`,
  };
  return fetch(`${fetchUrl}/customer`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${atob(sessionStorage.getItem("trueMfgToken"))}`,
    },
    body: JSON.stringify(requestBody),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Error getting customer data: ${response.statusText}`);
      }
      return response.json();
    })
    .then((response) => {
      Object.assign(accumulator, response.data[0]);
    })
    .catch((error) => {
      console.log("Error getting customer data:", error);
    });
}

function getSNResourceData(fetchUrl, accumulator) {
  return fetch(
    `${fetchUrl}?model=${accumulator.modelNumber}&wireDiagramPartNumber=${accumulator.wiringPart}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  )
    .then((response) => {
      if (!response.ok) {
        throw new Error(
          `Error fetching serial number resource data: ${response.statusText}`
        );
      }
      return response.json();
    })
    .then((response) => {
      Object.assign(accumulator, response);
    })
    .catch((error) => {
      console.log("Error fetching serial number resource data:", error);
    });
}

async function displayTable(accumulator, targetElement) {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };
  console.log(accumulator);
  let formattedDate = accumulator.shipDate
    ? formatDate(accumulator.shipDate)
    : "";

  // Look for a collection corresponding to the model number and create a link if there is one.
  let modelLookupOptions = Array.from(
    document.querySelectorAll("model-lookup option")
  );
  let modelCategories = modelLookupOptions.map((o) =>
    o.innerText.toLowerCase()
  );
  let modelNumber = accumulator.modelNumber || "";
  let modelCollectionLink = modelCategories.includes(modelNumber.toLowerCase())
    ? `/collections/${modelNumber.toLowerCase()}`
    : "";

  let modelInnerHtml = modelCollectionLink
    ? `<a href = "${modelCollectionLink}">${modelNumber}</a>`
    : modelNumber;

  let shelfHtml = "";
  accumulator.shelves?.forEach((e) => {
    let shelfNum = "";
    if (e.sparePartNum) {
      shelfNum = e.sparePartNum;
    } else if (e.itemNum) {
      shelfNum = e.itemNum;
    }
    shelfHtml += shelfNum
      ? `<tr> <td>Shelf</td><td><a href = "/search?q=${shelfNum}">${shelfNum}</a></td> </tr>`
      : "";
  });

  let gasketHtml = "";
  accumulator.gaskets?.forEach((e) => {
    let gasketNum = "";
    if (e.sparePartNum) {
      gasketNum = e.sparePartNum;
    } else if (e.itemNum) {
      gasketNum = e.itemNum;
    }
    gasketHtml += gasketNum
      ? `<tr> <td>Gasket</td> <td><a href = "/search?q=${gasketNum}">${gasketNum}</a></td> </tr>`
      : "";
  });

  let specSheetStatus = await checkUrlStatus(accumulator.spec_sheet);
  let specSheetHtml =
    specSheetStatus === 200
      ? `<div><a href="${accumulator.spec_sheet}" target="_blank">Spec Sheet</a></div>`
      : "";

  let cadFileStatus = await checkUrlStatus(accumulator.cad_file);
  let cadFileHtml =
    cadFileStatus === 200
      ? `<div><a href="${accumulator.cad_file}" target="_blank">CAD File</a></td></div>`
      : "";

  let wiringDiagramHtml = accumulator.wire_diagram
    ? `<div><a href="${accumulator.wire_diagram}">Wiring Diagram</a></div>`
    : "";

  let outputContent = `
	<table class="sni-results">
		<tr> <td>Serial Number</td> <td>${accumulator.serialNumber || "Invalid Serial Number"
    }</td></tr>
	 	<tr> <td>Model</td> <td>${modelInnerHtml}</td> </tr>
	 	<tr> <td>Ship Date</td> <td>${formattedDate}</td> </tr>`;
  if (__st.cid) {
    outputContent += accumulator.poNumber
      ? `<tr> <td>PO Number:</td> <td>${accumulator.poNumber}</td> </tr>`
      : "";
    outputContent += accumulator.invoiceNumber
      ? `<tr> <td>Invoice:</td> <td>${accumulator.invoiceNumber}</td> </tr>`
      : "";
    outputContent += accumulator.customerNumber
      ? `<tr> <td>Customer Number</td> <td>${accumulator.customerNumber}</td> </tr>`
      : "";
    outputContent += accumulator.billTo
      ? `<tr> <td>Bill To:</td> <td>${accumulator.billTo}</td> </tr>`
      : "";
    outputContent += accumulator.shipTo
      ? `<tr> <td>Ship To</td> <td>${accumulator.shipTo}</td> </tr>`
      : "";
  }
  outputContent += gasketHtml;
  outputContent += shelfHtml;
  outputContent += "</table>";

  outputContent += `
  <div class='resources-container'>
  <h4>Resources</h4>
  ${specSheetHtml}
  ${cadFileHtml}
  ${wiringDiagramHtml}
  </div>
  `;

  //outputContent += "<div class='resources-container'>";
  //outputContent += specSheetHtml;
  //outputContent += cadFileHtml;
  //outputContent += wiringDiagramHtml;
  //outputContent += "</div>";

  /*if(__st.cid && !accumulator.customerNumber && accumulator.serialNumber)
  outputContent +=
    !accumulator.customerNumber
      ? "<p>You are seeing limited data because you are not listed as the owner of the unit.</p>"
      : "";*/
  targetElement.innerHTML = outputContent;
}

async function checkUrlStatus(url) {
  if (url == null || url == "") {
    return 404;
  }

  try {
    const response = await fetch(url);
    return response.status;
  } catch (error) {
    return null;
  }
}

async function addToCart(variantId, qty) {
  console.log('adding variant to cart ' + variantId)
  const formData = {
    items: [{ id: variantId, quantity: qty }],
  };

  try {
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData),
    });
    return await response.json();
  } catch (error) {
    console.error('Error:', error);
  }
}


async function addToCart_clickEvent(variantId, qty) {
  const button = this;
  const svgContainer = button.querySelector('svg')?.parentNode || button;

  // Show loading (animated ellipsis)
  svgContainer.innerHTML = getWaitingSvg();

  await addToCart(variantId, qty);
  console.log('Added To Cart ' + variantId);

  // Show checkmark
  svgContainer.innerHTML = getCheckMarkSvg();

  // Reset to cart icon after a short delay
  setTimeout(() => {
    svgContainer.innerHTML = getCartSvg();
  }, 1500);

  $('.sticky-header-wrapper').load(window.location.href + ' .sticky-header-wrapper');
  $('#modal-cart-drawer').load(window.location.href + ' #modal-cart-drawer');
}



async function getProductVariant(partNumber) {
  console.log('Get Product Variant');
  const url = `https://shopifypartidlookup.azurewebsites.net/${partNumber}`;
  let returnData = 0;

  await $.get(url)
    .done((data) => {
      if (data.includes('Error')) {
        displayError(data);
      } else {
        returnData = data;
      }
    })
    .fail((error) => {
      displayError(
        'Server error retrieving product ID. Please try again. If this continues to occur, please contact support.'
      );
      console.error(error);
    });

  return returnData;
}

function getCartButton(variantId) {
  const disabled = variantId ? "" : "disabled-tops-cart-button";
  const onClick = variantId ? `onClick="addToCart_clickEvent.call(this,'${variantId}')` : "";
  return `
  <button type="button" class="page-header_icns-link tops_add-to-cart_button ${disabled}" ${onClick} ">
    ${getCartSvg()}
</button>`
}

function getWaitingSvg() {
  return `  
<svg viewBox="0 0 20 20" width="20" height="20" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
  <circle cx="4" cy="10" r="2">
    <animate attributeName="opacity" values="0;1;0" dur="1.2s" begin="0s" repeatCount="indefinite"/>
  </circle>
  <circle cx="10" cy="10" r="2">
    <animate attributeName="opacity" values="0;1;0" dur="1.2s" begin="0.2s" repeatCount="indefinite"/>
  </circle>
  <circle cx="16" cy="10" r="2">
    <animate attributeName="opacity" values="0;1;0" dur="1.2s" begin="0.4s" repeatCount="indefinite"/>
  </circle>
</svg>

  `
}

function getCartSvg() {
  return `
  <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="ico ico-add-cart"
    viewBox="0 0 20 20" fill="none">
    <use href="#icn-cart"></use>
  </svg>
  `
}

function getCheckMarkSvg() {
  return `
  <svg viewBox="0 0 20 20" width="20" height="20" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="2">
    <path d="M5 10 L8 13 L15 6">
      <animate attributeName="stroke-dasharray" from="0,20" to="20,0" dur="0.5s" fill="freeze" />
    </path>
  </svg>

  `
}